import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Lock, User, AlertCircle } from 'lucide-react';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setError(result.error);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <span className="text-5xl">🐱</span>
          <h1 className="font-heading text-2xl font-bold text-forest mt-4">
            La Taïga Siberia
          </h1>
          <p className="font-body text-forest/60 mt-1">Administration</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-3xl shadow-soft p-8">
          <h2 className="font-heading text-xl font-semibold text-forest mb-6 text-center">
            Connexion
          </h2>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 flex items-center gap-3">
              <AlertCircle className="w-5 h-5 text-red-500" />
              <p className="font-body text-sm text-red-700">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username" className="font-body text-sm font-semibold text-forest">
                Identifiant
              </Label>
              <div className="relative mt-1">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-forest/40" />
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="pl-10 bg-cream border-sand"
                  placeholder="admin"
                  required
                  data-testid="admin-username"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="font-body text-sm font-semibold text-forest">
                Mot de passe
              </Label>
              <div className="relative mt-1">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-forest/40" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 bg-cream border-sand"
                  placeholder="••••••••"
                  required
                  data-testid="admin-password"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-forest hover:bg-forest-dark text-white font-body font-semibold py-6 rounded-full mt-6"
              data-testid="admin-login-btn"
            >
              {isLoading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </div>

        <p className="text-center mt-6 font-body text-sm text-forest/50">
          <a href="/" className="hover:text-autumn">← Retour au site</a>
        </p>
      </div>
    </div>
  );
}
